import React from 'react';
import PropTypes from 'prop-types';
import Icon from "../../Atoms/Icon";


const PayrollSummaryItem = props => {
  const {className, icon, title, content, isDropdown} = props
  return (
    <article className={`payroll-summary-item flex nowrap s-mb-0 ${className}`}>
      <div className="flex-none s-mr-4px s-pt-2px">
        <Icon svg={icon} />
      </div>
      <div>
        <div className="s-cross-center nowrap">
          <p className="s-mb-0 small s-mr-8px">{title}</p>
          {isDropdown && (
            <Icon svg="down" size="0.75rem"/>
          )}
        </div>
        <p className="content s-mb-0 t3 s-color-blue">{content}</p>
      </div>
    </article>
  );
};

PayrollSummaryItem.propTypes = {
  className: PropTypes.string,
  icon: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  content: PropTypes.string.isRequired,
  isDropdown: PropTypes.bool,
};

PayrollSummaryItem.defaultProps = {
  className: '',
  isDropdown: false,
}

export default PayrollSummaryItem;
